import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2bb55e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-box" }
const _hoisted_2 = { class: "showtime" }
const _hoisted_3 = { class: "goods-info" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "attrs" }
const _hoisted_6 = { class: "goods-footer" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/icon/play.png" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "goods-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goto(_ctx.goods.cid, _ctx.goods.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("img", null, null, 512), [
        [_directive_lazy, _ctx.imgUrl(_ctx.goods.names, _ctx.goods.cover)]
      ]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.videoFormat(_ctx.goods.duration * 1000)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goods.names), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.goods.attr) + " ", 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.goods.click) + "次播放 ", 1)
        ])
      ])
    ])
  ]))
}